enum BillingsTaxiTransferredOrderListingItemBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPENED = "REOPENED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
}

export default BillingsTaxiTransferredOrderListingItemBillingStatus;
